import React, {useState, useEffect} from 'react';
import {
    BrowserRouter as Router,
    Routes,
    Route,
    Link as RouterLink,
    Navigate,
} from 'react-router-dom';
import {
    AppBar,
    Toolbar,
    Typography,
    Button,
    Container,
    Box,
    ThemeProvider,
    createTheme,
} from '@mui/material';
import axios from 'axios';

// Import pages
import Login from './pages/Login';
import Register from './pages/Register';
import Profile from './pages/Profile';
import Imprint from './pages/Imprint';
import PrivacyPolicy from './pages/PrivacyPolicy';

const greenTheme = createTheme({
    palette: {
        primary: {
            main: '#27552c', // Dark Green
        },
    },
});

function App() {
    const [isAuthenticated, setIsAuthenticated] = useState(false);

    useEffect(() => {
        const token = localStorage.getItem('token');
        if (token) {
            axios.defaults.headers.common['Authorization'] = `Token ${token}`;
            setIsAuthenticated(true);
        }
    }, []);

    const handleLogout = () => {
        localStorage.removeItem('token');
        delete axios.defaults.headers.common['Authorization'];
        setIsAuthenticated(false);
    };

    return (
        <ThemeProvider theme={greenTheme}>
            <Router>
                <AppBar position="static">
                    <Toolbar>
                        <Box
                            component="img"
                            sx={{height: 40, mr: 2}}
                            alt="Observatorium Logo"
                            src="/logo192.png"
                        />
                        <Typography variant="h6" component="div" sx={{flexGrow: 1}}>
                            Observatorium
                        </Typography>
                        {isAuthenticated ? (
                            <>
                                <Button color="inherit" component={RouterLink} to="/profile">
                                    Profile
                                </Button>
                                <Button color="inherit" onClick={handleLogout}>
                                    Logout
                                </Button>
                            </>
                        ) : (
                            <>
                                <Button color="inherit" component={RouterLink} to="/login">
                                    Login
                                </Button>
                                <Button color="inherit" component={RouterLink} to="/register">
                                    Register
                                </Button>
                            </>
                        )}
                    </Toolbar>
                </AppBar>
                <Container>
                    <Box mt={4}>
                        <Routes>
                            <Route
                                path="/login"
                                element={<Login setAuth={setIsAuthenticated}/>}
                            />
                            <Route
                                path="/register"
                                element={<Register setAuth={setIsAuthenticated}/>}
                            />
                            <Route
                                path="/profile"
                                element={isAuthenticated ? <Profile/> : <Navigate to="/login"/>}
                            />
                            <Route
                                path="/imprint"
                                element={<Imprint/>}
                            />
                            <Route
                                path="/privacy_policy"
                                element={<PrivacyPolicy/>}
                            />
                            <Route
                                path="/"
                                element={
                                    isAuthenticated ? (
                                        <Navigate to="/profile"/>
                                    ) : (
                                        <Navigate to="/login"/>
                                    )
                                }
                            />
                        </Routes>
                    </Box>
                </Container>
            </Router>
        </ThemeProvider>
    );
}

export default App;
